import PropTypes from 'prop-types';
import React, { useRef, useEffect, useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import TagFilter from './TagFilter';
import RefreshCwIcon from '../../shared/Icons/RefreshCwIcon';

var moment = require('moment');
import DayPicker from 'react-day-picker';
import Popup from "reactjs-popup";
import { SketchPicker } from 'react-color'
const axios = require('axios').default;

import $ from 'jquery';
require('datatables.net-bs4');

import '../styles/calendarMenuStyles.css';

const contentStyle = {
  "border": "none",
  "borderRadius": "8px",
  "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  "width": "201px",
  "padding": "15px 15px 10px 15px"
}

const CustomNavbar = ({ onPreviousClick, onNextClick, className }) => {
  return (
    <div className={`${className} d-flex justify-content-end`}>
      <button onClick={() => onPreviousClick()} className="custom-prev">
        <i className="fas fa-chevron-left"></i>
      </button>
      <button onClick={() => onNextClick()} className="custom-next">
        <i className="fas fa-chevron-right"></i>
      </button>
    </div>
  );
};

const autoSaveRoom = (csrfToken, team, room, dataTableEl) => {
  axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;

  axios.patch(`/teams/${team.id}/rooms/${room.id}`, {
    room: {
      calendar_color_hex: room.calendar_color_hex
    }
  }).then(() => {
    $(dataTableEl).DataTable().ajax.reload();
  });
};

const RoomCheckBox = ({
  room,
  selectedRooms,
  selectedTags,
  setSelectedRooms,
  dataTableFilters,
  dataTableFiltersChanged,
  fetchCalendarEventsForSelectedVenues,
  fetchTeamVenueConflicts,
  saveTeamMembershipCalendarState,
  team,
  csrfToken,
  canSelectMultipleVenues,
  user,
  currentTeamMembership,
  roomsChanged,
  dataTableEl,
  rooms
}) => {
  const [currentColor, setCurrentColor] = useState(room.calendar_color_hex);

  var isChecked = selectedRooms
    .map((r) => r.value)
    .includes(room.id);

  return (
    <div className='d-flex align-items-center justify-content-between my-calendar-venue-option'
          style={{"height": "22px"}}>
      <div className="form-check w-100 d-flex align-items-center">
        <input className="form-check-input"
                style={{
                  "marginTop": "0px",
                  "background": isChecked ? room.calendar_color_hex : "var(--od-c-ffffff, white)",
                  "border": isChecked ? `1px solid ${room.calendar_color_hex}` : "1px solid var(--od-c-333333, #333)",
                }}
                type="checkbox"
                checked={isChecked}
                onChange={
                  (e) => {
                    var updated = [];

                    if(canSelectMultipleVenues){
                      if(e.target.checked){
                        updated = [...selectedRooms, { value: room.id, label: room.name }];
                      } else {
                        updated = selectedRooms.filter((s) => s.value !== room.id);
                      }
                    } else {
                      if(e.target.checked){
                        updated = [{ value: room.id, label: room.name }];
                      } else {
                        updated = [];
                      }
                    }

                    setSelectedRooms(updated);
                    fetchCalendarEventsForSelectedVenues(team, updated, selectedTags);
                    fetchTeamVenueConflicts(team, updated, user);

                    dataTableFiltersChanged(Object.assign({}, dataTableFilters, {
                      room_ids: updated.map((s) =>  s.value)
                    }));

                    saveTeamMembershipCalendarState(csrfToken, team, currentTeamMembership, {
                      calendar_room_ids: updated.map((s) => s.value)
                    });
                  }
                }
                id={`calendar-room-${room.id}`} />
        <label className="form-check-label text-truncate w-100"
                style={{
                  fontSize: "12px",
                  marginLeft: "-3px",
                  maxWidth: "150px",
                  marginBottom: "-2px"
                }}
                title={room.name}
                htmlFor={`calendar-room-${room.id}`}>
          {room.name}
        </label>
      </div>
      <Popup arrow={false}
            offsetY={3}
            offsetX={8}
            position="bottom right"
            contentStyle={contentStyle}
            onOpen={
              (e) => {
                e.preventDefault();
              }
            }
            trigger={open => (
        <a href="#"
            onClick={
              (e) => {
                e.preventDefault();
              }
            }
            className='text-dark small venue-color-control'>
          <i className="fas fa-sliders-h"></i>
        </a>
      )} >
        {close => (
          <div className='venue-color-popup'>
            <p className='mb-0'
                style={{"fontSize": "14px"}}>
              <strong>Choose calendar color</strong>
            </p>
            <SketchPicker width={"169px"}
                          color={currentColor}
                          onChange={
                            (color) => {
                              setCurrentColor(color.hex);
                            }
                          }
                          onChangeComplete={
                            (color) => {
                              var updatedRoom = {
                                ...room,
                                calendar_color_hex: color.hex
                              };

                              var updatedRooms = [...rooms].map((r) => {
                                if(r.id === room.id){
                                  return updatedRoom;
                                } else {
                                  return r;
                                }
                              });

                              roomsChanged(updatedRooms);
                              autoSaveRoom(csrfToken, team, updatedRoom, dataTableEl);
                            }
                          }
                          presetColors={[]} />
          </div>
        )}
      </Popup>
    </div>
  );
};

const CategoryCheckBox = ({
  htmlFor,
  label,
  isChecked,
  onChange
}) => {
  return (
    <div className='d-flex align-items-center justify-content-between my-calendar-venue-option py-0' style={{marginTop: "3px"}}>
      <div className="form-check w-100 d-flex align-items-center">
        <input className="form-check-input"
                style={{
                  "marginTop": "0px",
                  "background": isChecked ? "#1f81c2" : "var(--od-c-ffffff, white)",
                  "border": isChecked ? `1px solid #1f81c2` : "1px solid var(--od-c-d9d9d9, #d9d9d9)",
                }}
                type="checkbox"
                checked={isChecked}
                onChange={onChange}
                id={htmlFor} />
        <label className="form-check-label w-100"
                style={{
                  fontSize: "12px",
                  marginLeft: "-3px"
                }}
                htmlFor={htmlFor}>
          {label}
        </label>
      </div>
    </div>
  );
};

const CalendarMenu = ({
  team,
  csrfToken,
  user,
  currentTeamMembership,
  saveTeamMembershipCalendarState,
  currentTeamMembershipChanged,
  venuesOptions,
  setSelectedVenues,
  fetchCalendarEventsForSelectedVenues,
  selectedTags,
  fetchTeamVenueConflicts,
  dataTableFilters,
  dataTableFiltersChanged,
  venueOwnerships,
  canSelectMultipleVenues,
  venueOwnershipsChanged,
  onSaleEnabled,
  announcedEnabled,
  confirmedEnabled,
  holdsEnabled,
  pastEventsEnabled,
  cancelledEventsEnabled,
  toggleOnSaleEnabled,
  toggleAnnouncedEnabled,
  toggleConfirmedEnabled,
  toggleHoldsEnabled,
  togglePastEventsEnabled,
  toggleCancelledEventsEnabled,
  setSelectedTags,
  searchTermChanged,
  dataTableEl,
  preSaleEnabled,
  togglePreSaleEnabled,
  artistPreSaleEnabled,
  toggleArtistPreSaleEnabled,
  browser,
  datesAreOnSameDay,
  setGoToSpecificDate,
  scrollCalendarToDate,
  setTeamMembershipCurrentDate,
  calendarContainerRef,
  rooms,
  selectedRooms,
  setSelectedRooms,
  roomsChanged,
  reorderRooms,
  calendarEventSeries,
  isMobileDropdown = false
}) => {
  // Use team_membership state for both desktop and mobile
  const myCalendarsOpen = currentTeamMembership.my_calendars_menu_open;
  const categoriesOpen = currentTeamMembership.categories_menu_open;
  const tagsOpen = currentTeamMembership.tags_menu_open;
  const [recurringSeriesOpen, setRecurringSeriesOpen] = useState(true);
  const buttonClasses = (teamMembership, value) => {
    if(teamMembership.calendar_view === value){
      return "btn-outline-dark btn-outline-dark-calendar-menu";
    } else {
      return "btn-link text-muted";
    }
  }

  const miniCalendarRef = useRef(null);
  const highlightCurrentWeek = () => {
    if (!miniCalendarRef.current) return;
    let dayPicker = miniCalendarRef.current.dayPicker;
    let calendarRows = dayPicker.getElementsByClassName("DayPicker-Week");
    let targetDate = new Date(currentTeamMembership.calendar_starts_at);

    Array.from(calendarRows).forEach((row) => {
      let dayElsInRow = Array.from(row.querySelectorAll('.DayPicker-Day'));
      let rowContainsStartDate = dayElsInRow.find(
        (day) => {
          let currentDate = new Date(day.ariaLabel);
          return datesAreOnSameDay(currentDate, targetDate);
        }
      );

      if (rowContainsStartDate) {
        row.classList.add('DayPicker-Week--today');
      } else {
        row.classList.remove('DayPicker-Week--today');
      }
    });
  };

  useEffect(() => {
    setTimeout(() => {
      highlightCurrentWeek();
    }, 1);
  }, [miniCalendarRef, currentTeamMembership.calendar_starts_at]);

  const allRoomsChecked = rooms.every((room) => {
    return selectedRooms.some((r) => r.value === room.id);
  });

  const onRoomsDragEnd = (result) => {
    if (!result.destination) return;
    if (result.destination.index === result.source.index) return;

    const reordered = Array.from(rooms);
    const [moved] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, moved);

    reorderRooms(csrfToken, team, reordered);
  };

  const allCategoriesChecked = (
    onSaleEnabled
      && announcedEnabled
      && confirmedEnabled
      && holdsEnabled
      && pastEventsEnabled
      && cancelledEventsEnabled
      && preSaleEnabled
      && (team.mode !== "AGENT_MANAGER" || artistPreSaleEnabled)
  );

  return(
    <div className='card border-0 shadow-1'
          style={{
            "width": "265px",
            "minWidth": "265px",
            "borderRadius": "8px"
          }}>
      {!browser.is.small && !browser.is.extraSmall ? (
        <>
          <div className='card-body flex-grow-0' style={{padding: "20px 15px 10px 15px"}}>
            <div className='d-flex justify-content-between align-items-center'>
              <span style={{fontSize: "16px", fontWeight: "600"}}>
                Calendar
              </span>
            </div>
          </div>
          <div className='card-body flex-grow-0' style={{padding: "0px 15px 20px 15px"}}>
            <div className='d-flex justify-content-between align-items-center'
                  style={{
                    border: "1px solid var(--od-c-f7f7f7, #F7F7F7)",
                    background: "var(--od-c-fafafa, #FAFAFA)",
                    borderRadius: "4px",
                    padding: "2px"
                  }}>
              <a href="#"
                  className={`btn btn-sm small ${buttonClasses(currentTeamMembership, "calendar_daily")}`}
                  onClick={
                    (e) => {
                      e.preventDefault();

                      var updated = {
                        ...currentTeamMembership,
                        calendar_view: "calendar_daily"
                      }

                      searchTermChanged("");
                      currentTeamMembershipChanged(updated);
                      saveTeamMembershipCalendarState(csrfToken, team, currentTeamMembership, {
                        calendar_view: updated.calendar_view
                      });

                      setGoToSpecificDate(currentTeamMembership.calendar_starts_at);
                  }
                  }
                  style={{"width": "50px", whiteSpace: "nowrap"}}>
                <strong>Day</strong>
              </a>
              <a href="#"
                  className={`btn btn-sm small ${buttonClasses(currentTeamMembership, "calendar_weekly")}`}
                  onClick={
                    (e) => {
                      e.preventDefault();

                      var updated = {
                        ...currentTeamMembership,
                        calendar_view: "calendar_weekly"
                      }

                      searchTermChanged("");
                      currentTeamMembershipChanged(updated);
                      saveTeamMembershipCalendarState(csrfToken, team, currentTeamMembership, {
                        calendar_view: updated.calendar_view
                      });

                      setGoToSpecificDate(currentTeamMembership.calendar_starts_at);
                  }
                  }
                  style={{"width": "50px", whiteSpace: "nowrap"}}>
                <strong>Week</strong>
              </a>
              <a href="#"
                  className={`btn btn-sm small ${buttonClasses(currentTeamMembership, "calendar")}`}
                  onClick={
                    (e) => {
                      e.preventDefault();

                      var updated = {
                        ...currentTeamMembership,
                        calendar_view: "calendar"
                      }

                      searchTermChanged("");
                      currentTeamMembershipChanged(updated);
                      saveTeamMembershipCalendarState(csrfToken, team, currentTeamMembership, {
                        calendar_view: updated.calendar_view
                      });
                  }
                  }
                  style={{"width": "55px", whiteSpace: "nowrap"}}>
                <strong>Month</strong>
              </a>
              <a href="#"
                  className={`btn btn-sm small ${buttonClasses(currentTeamMembership, "list")}`}
                  onClick={
                    (e) => {
                      e.preventDefault();

                      var updated = {
                        ...currentTeamMembership,
                        calendar_view: "list"
                      }

                      currentTeamMembershipChanged(updated);
                      saveTeamMembershipCalendarState(csrfToken, team, currentTeamMembership, {
                        calendar_view: updated.calendar_view
                      });
                  }
                  }
                  style={{"width": "50px", whiteSpace: "nowrap"}}>
                <strong>List</strong>
              </a>
            </div>
          </div>
        </>
      ) : null}
      <div className='card-body flex-grow-0'
            style={{
              "padding": "10px 15px 5px 15px",
              "borderTop": "1px solid var(--od-c-f5f5f5, #f5f5f5)"
            }}>
        <DayPicker
          ref={miniCalendarRef}
          className='day-picker-calendar-minimap'
          month={new Date(currentTeamMembership.calendar_starts_at)}
          selectedDays={new Date(currentTeamMembership.calendar_starts_at)}
          showOutsideDays={true}
          firstDayOfWeek={user.calendar_start_day}
          navbarElement={<CustomNavbar />}
          onMonthChange={highlightCurrentWeek}
          onDayClick={
            (date, {selected}) => {
              var prevDate = new Date(currentTeamMembership.calendar_starts_at);

              if(currentTeamMembership.calendar_view === "list"){
                setTeamMembershipCurrentDate(date);
                return false;
              }

              if (currentTeamMembership.calendar_view === "calendar_daily") {
                // For day view, always navigate to the clicked date
                if(datesAreOnSameDay(prevDate, date)) {
                  return false;
                }
              }

              if (currentTeamMembership.calendar_view === "calendar_weekly") {
                const prevWeekStart = moment(prevDate).startOf('week');
                const newWeekStart = moment(date).startOf('week');

                if(prevWeekStart.isSame(newWeekStart, 'week')) {
                  return false;
                }
              }

              if (currentTeamMembership.calendar_view === "calendar") {
                var shouldScrollOnly = (
                  prevDate.getMonth() === date.getMonth() &&
                    prevDate.getFullYear() === date.getFullYear()
                );

                if(shouldScrollOnly){
                  setTimeout(() => {
                    scrollCalendarToDate(date);
                  }, 0);

                  setTeamMembershipCurrentDate(date);
                  return false;
                }
              }

              setGoToSpecificDate(date);
            }
          } />
      </div>
      {calendarEventSeries && calendarEventSeries.length > 0 ? (
        <div className='card-body flex-grow-0 recurring-series-card'>
          <div className='d-flex justify-content-between align-items-center position-relative'>
            <p className='small mb-0'>
              <strong className='recurring-series-heading'>Recurring series</strong>
            </p>
            <a href="#"
                onClick={
                  (e) => {
                    e.preventDefault();
                    setRecurringSeriesOpen(!recurringSeriesOpen);
                  }
                }
                className='text-muted small stretched-link'>
              {recurringSeriesOpen ? (
                <i className="fas fa-chevron-up"></i>
              ) : (
                <i className="fas fa-chevron-down"></i>
              )}
            </a>
          </div>
          {recurringSeriesOpen ? (
            <div className='row'>
              <div className='col-12 recurring-series-list'>
                {calendarEventSeries.map((series) => (
                  <a key={series.id}
                      href={series.show_url}
                      className='d-flex align-items-center justify-content-between my-calendar-venue-option text-dark text-decoration-none recurring-series-link'>
                    <div className='d-flex align-items-center text-truncate recurring-series-name-wrap'>
                      <div className='recurring-series-badge'>
                        <RefreshCwIcon fill="#1982C4" width="10" height="10" />
                      </div>
                      <span className='text-truncate recurring-series-name'
                            title={series.name}>
                        {series.name}
                      </span>
                    </div>
                    <span className='text-muted recurring-series-count'>
                      {series.events_count}
                    </span>
                  </a>
                ))}
              </div>
            </div>
          ) : null}
        </div>
      ) : null}
      <div className='card-body flex-grow-0' style={{padding: "20px 15px", "borderTop": "1px solid var(--od-c-f5f5f5, #f5f5f5)"}}>
        <div className='d-flex justify-content-between align-items-center position-relative'>
          <p className='small mb-0'>
            <strong style={{fontSize: "14px"}}>My Calendars</strong>
          </p>
          <a href="#"
              onClick={
                (e) => {
                  e.preventDefault();

                  var updated = {
                    ...currentTeamMembership,
                    my_calendars_menu_open: !currentTeamMembership.my_calendars_menu_open
                  }

                  currentTeamMembershipChanged(updated);
                  saveTeamMembershipCalendarState(csrfToken, team, currentTeamMembership, {
                    my_calendars_menu_open: updated.my_calendars_menu_open
                  });
                }
              }
              className='text-muted small stretched-link'>
            {myCalendarsOpen ? (
              <i className="fas fa-chevron-up"></i>
            ) : (
              <i className="fas fa-chevron-down"></i>
            )}
          </a>
        </div>
        {myCalendarsOpen ? (
          <div className='row'>
            <div className='col-12'
                  style={{
                    marginTop: "5px",
                    padding: "0 11px"
                  }}>
              {canSelectMultipleVenues ? (
                <div className='d-flex align-items-center justify-content-between my-calendar-venue-option'
                      style={{"height": "22px"}}>
                  <div className="form-check w-100 d-flex align-items-center">
                    <input className="form-check-input"
                            style={{
                              "marginTop": "0px",
                              "background": allRoomsChecked ? "var(--od-c-1982c4, #1982C4)" : "var(--od-c-ffffff, white)",
                              "border": allRoomsChecked ? `1px solid var(--od-c-1982c4, #1982C4)` : "1px solid var(--od-c-333333, #333)",
                            }}
                            type="checkbox"
                            checked={allRoomsChecked}
                            onChange={
                              (e) => {
                                var updated = [];

                                if(allRoomsChecked){
                                  updated = [];
                                } else {
                                  updated = [...rooms].map((r) => {
                                    return { "value": r.id, "label": r.name }
                                  });
                                }

                                setSelectedRooms(updated);
                                fetchCalendarEventsForSelectedVenues(team, updated, selectedTags);
                                fetchTeamVenueConflicts(team, updated, user);

                                dataTableFiltersChanged(Object.assign({}, dataTableFilters, {
                                  room_ids: updated.map((s) =>  s.value)
                                }));

                                saveTeamMembershipCalendarState(csrfToken, team, currentTeamMembership, {
                                  calendar_room_ids: updated.map((s) => s.value)
                                });
                              }
                            }
                            id={`calendar-venue-select-all`} />
                    <label className="form-check-label text-truncate w-100"
                            style={{
                              fontSize: "12px",
                              marginLeft: "-3px",
                              maxWidth: "150px",
                              marginBottom: "-2px"
                            }}
                            htmlFor={`calendar-venue-select-all`}>
                      Select all
                    </label>
                  </div>
                </div>
              ) : null}
              <DragDropContext onDragEnd={onRoomsDragEnd}>
                <Droppable droppableId="my-calendars-rooms">
                  {(droppableProvided) => (
                    <div ref={droppableProvided.innerRef} {...droppableProvided.droppableProps}>
                      {rooms.map((room, index) => (
                        <Draggable key={room.id} draggableId={String(room.id)} index={index}>
                          {(draggableProvided, snapshot) => (
                            <div ref={draggableProvided.innerRef}
                                  {...draggableProvided.draggableProps}
                                  {...draggableProvided.dragHandleProps}
                                  style={{
                                    ...draggableProvided.draggableProps.style,
                                    cursor: snapshot.isDragging ? 'grabbing' : 'grab'
                                  }}>
                              <RoomCheckBox room={room}
                                            selectedRooms={selectedRooms}
                                            selectedTags={selectedTags}
                                            setSelectedRooms={setSelectedRooms}
                                            dataTableFilters={dataTableFilters}
                                            dataTableFiltersChanged={dataTableFiltersChanged}
                                            fetchCalendarEventsForSelectedVenues={fetchCalendarEventsForSelectedVenues}
                                            fetchTeamVenueConflicts={fetchTeamVenueConflicts}
                                            saveTeamMembershipCalendarState={saveTeamMembershipCalendarState}
                                            team={team}
                                            csrfToken={csrfToken}
                                            user={user}
                                            currentTeamMembership={currentTeamMembership}
                                            canSelectMultipleVenues={canSelectMultipleVenues}
                                            roomsChanged={roomsChanged}
                                            dataTableEl={dataTableEl}
                                            rooms={rooms} />
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {droppableProvided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            </div>
          </div>
        ) : null}
      </div>
      <div className='card-body flex-grow-0' style={{padding: "20px 15px", "borderTop": "1px solid var(--od-c-f5f5f5, #f5f5f5)"}}>
        <div className='d-flex justify-content-between align-items-center position-relative'>
          <p className='small mb-0'>
            <strong style={{fontSize: "14px"}}>Categories</strong>
          </p>
          <a href="#"
              onClick={
                (e) => {
                  e.preventDefault();

                  var updated = {
                    ...currentTeamMembership,
                    categories_menu_open: !currentTeamMembership.categories_menu_open
                  }

                  currentTeamMembershipChanged(updated);
                  saveTeamMembershipCalendarState(csrfToken, team, currentTeamMembership, {
                    categories_menu_open: updated.categories_menu_open
                  });
                }
              }
              className='text-muted small stretched-link'>
            {categoriesOpen ? (
              <i className="fas fa-chevron-up"></i>
            ) : (
              <i className="fas fa-chevron-down"></i>
            )}
          </a>
        </div>
        {categoriesOpen ? (
          <div className='row'>
            <div className='col-12'
                  style={{
                    marginTop: "5px",
                    padding: "0 11px"
                  }}>
              <CategoryCheckBox htmlFor={"calendar-categories-select-all"}
                          isChecked={allCategoriesChecked}
                          label={
                            <div className='d-flex align-items-center'>
                              <div className='text-truncate'>
                                Select all
                              </div>
                            </div>
                          }
                          onChange={
                            (e) => {
                              if(allCategoriesChecked){
                                toggleOnSaleEnabled(false);
                                toggleAnnouncedEnabled(false);
                                toggleConfirmedEnabled(false);
                                toggleHoldsEnabled(false);
                                togglePastEventsEnabled(false);
                                toggleCancelledEventsEnabled(false);
                                togglePreSaleEnabled(false);
                                toggleArtistPreSaleEnabled(false);

                                saveTeamMembershipCalendarState(csrfToken, team, currentTeamMembership, {
                                  calendar_on_sale_enabled: false,
                                  calendar_announced_enabled: false,
                                  calendar_holds_enabled: false,
                                  calendar_confirmed_enabled: false,
                                  calendar_past_events_enabled: false,
                                  calendar_cancelled_events_enabled: false,
                                  calendar_pre_sale_enabled: false
                                });
                              } else {
                                toggleOnSaleEnabled(true);
                                toggleAnnouncedEnabled(true);
                                toggleConfirmedEnabled(true);
                                toggleHoldsEnabled(true);
                                togglePastEventsEnabled(true);
                                toggleCancelledEventsEnabled(true);
                                togglePreSaleEnabled(true);
                                toggleArtistPreSaleEnabled(true);

                                saveTeamMembershipCalendarState(csrfToken, team, currentTeamMembership, {
                                  calendar_on_sale_enabled: true,
                                  calendar_announced_enabled: true,
                                  calendar_holds_enabled: true,
                                  calendar_confirmed_enabled: true,
                                  calendar_past_events_enabled: true,
                                  calendar_cancelled_events_enabled: true,
                                  calendar_pre_sale_enabled: true
                                });
                              }
                            }
                          } />
              <CategoryCheckBox htmlFor={"calendar-holds-enabled"}
                                isChecked={holdsEnabled}
                                label={
                                  <div className='d-flex align-items-center justify-content-between'>
                                    <div className='d-flex align-items-center'>
                                      <img src="icons/hold.svg" style={{width: "14px", marginRight: "4px"}} />
                                      <div className='text-truncate'>
                                        Holds
                                      </div>
                                    </div>
                                    {holdsEnabled ? (
                                      <div className="custom-control custom-switch calendar-version-toggle show-cleared">
                                        <input type="checkbox"
                                                className="custom-control-input"
                                                checked={currentTeamMembership.show_cleared_holds || false}
                                                onChange={
                                                  (e) => {
                                                    let scroller;
                                                    let scrollPosition = 0;

                                                    var updated = {
                                                      ...currentTeamMembership,
                                                      show_cleared_holds: !currentTeamMembership.show_cleared_holds
                                                    }

                                                    if(calendarContainerRef.current){
                                                      scroller = calendarContainerRef.current.querySelector('.fc-scroller-liquid-absolute');
                                                      scrollPosition = scroller.scrollTop;
                                                    }

                                                    var onSuccess = () => {
                                                      if(currentTeamMembership.calendar_view === "list" && Object.keys(dataTableEl).length > 0){
                                                        $(dataTableEl).DataTable().ajax.reload();
                                                      } else {
                                                        fetchCalendarEventsForSelectedVenues(team, selectedRooms, selectedTags, () => {
                                                          if(scroller){
                                                            scroller.scrollTop = scrollPosition;
                                                          }
                                                        });
                                                      }
                                                    }

                                                    currentTeamMembershipChanged(updated);
                                                    saveTeamMembershipCalendarState(csrfToken, team, currentTeamMembership, {
                                                      show_cleared_holds: updated.show_cleared_holds
                                                    }, onSuccess);
                                                  }
                                                }
                                                id="team-membership-show-cleared-holds" />
                                        <label className="custom-control-label"
                                                style={{
                                                  fontSize: "12px",
                                                  fontWeight: "600"
                                                }}
                                                htmlFor="team-membership-show-cleared-holds">
                                          Show cleared
                                        </label>
                                      </div>
                                    ) : null}
                                  </div>
                                }
                                onChange={
                                  (e) => {
                                    toggleHoldsEnabled(!holdsEnabled);

                                    saveTeamMembershipCalendarState(csrfToken, team, currentTeamMembership, {
                                      calendar_holds_enabled: !holdsEnabled
                                    });
                                  }
                                } />
              <CategoryCheckBox htmlFor={"calendar-confirmed-enabled"}
                                isChecked={confirmedEnabled}
                                label={
                                  <div className='d-flex align-items-center'>
                                    <img src="icons/calendar-check.svg" style={{width: "14px", marginRight: "4px"}} />
                                    <div className='text-truncate'>
                                      Confirms
                                    </div>
                                  </div>
                                }
                                onChange={
                                  (e) => {
                                    toggleConfirmedEnabled(!confirmedEnabled);

                                    saveTeamMembershipCalendarState(csrfToken, team, currentTeamMembership, {
                                      calendar_confirmed_enabled: !confirmedEnabled
                                    });
                                  }
                                } />
              <CategoryCheckBox htmlFor={"calendar-announced-enabled"}
                                isChecked={announcedEnabled}
                                label={
                                  <div className='d-flex align-items-center'>
                                    <img src="icons/announcement.svg" style={{width: "14px", marginRight: "4px"}} />
                                    <div className='text-truncate'>
                                      Announce
                                    </div>
                                  </div>
                                }
                                onChange={
                                  (e) => {
                                    toggleAnnouncedEnabled(!announcedEnabled);

                                    saveTeamMembershipCalendarState(csrfToken, team, currentTeamMembership, {
                                      calendar_announced_enabled: !announcedEnabled
                                    });
                                  }
                                } />
              {team.mode === "AGENT_MANAGER" ? (
                <CategoryCheckBox htmlFor={"calendar-artist-pre-sale-events-enabled"}
                                  isChecked={artistPreSaleEnabled}
                                  label={
                                    <div className='d-flex align-items-center'>
                                      <img src="icons/pre-sale.svg" style={{width: "14px", marginRight: "4px"}} />
                                      <div className='text-truncate'>
                                        Artist Pre-sale
                                      </div>
                                    </div>
                                  }
                                  onChange={
                                    (e) => {
                                      toggleArtistPreSaleEnabled(!artistPreSaleEnabled);

                                      saveTeamMembershipCalendarState(csrfToken, team, currentTeamMembership, {
                                        calendar_artist_pre_sale_enabled: !artistPreSaleEnabled
                                      });
                                    }
                                  } />
              ) : null}
              <CategoryCheckBox htmlFor={"calendar-pre-sale-events-enabled"}
                                isChecked={preSaleEnabled}
                                label={
                                  <div className='d-flex align-items-center'>
                                    <img src="icons/pre-sale.svg" style={{width: "14px", marginRight: "4px"}} />
                                    <div className='text-truncate'>
                                      Pre-sale
                                    </div>
                                  </div>
                                }
                                onChange={
                                  (e) => {
                                    togglePreSaleEnabled(!preSaleEnabled);

                                    saveTeamMembershipCalendarState(csrfToken, team, currentTeamMembership, {
                                      calendar_pre_sale_enabled: !preSaleEnabled
                                    });
                                  }
                                } />
              <CategoryCheckBox htmlFor={"calendar-on-sale-enabled"}
                                isChecked={onSaleEnabled}
                                label={
                                  <div className='d-flex align-items-center'>
                                    <img src="icons/ticket.svg" style={{width: "14px", marginRight: "4px"}} />
                                    <div className='text-truncate'>
                                      On Sale
                                    </div>
                                  </div>
                                }
                                onChange={
                                  (e) => {
                                    toggleOnSaleEnabled(!onSaleEnabled);

                                    saveTeamMembershipCalendarState(csrfToken, team, currentTeamMembership, {
                                      calendar_on_sale_enabled: !onSaleEnabled
                                    });
                                  }
                                } />
              <CategoryCheckBox htmlFor={"calendar-past-events-enabled"}
                                isChecked={pastEventsEnabled}
                                label={
                                  <div className='d-flex align-items-center'>
                                    <img src="icons/past.svg" style={{width: "14px", marginRight: "4px"}} />
                                    <div className='text-truncate'>
                                      Past Events
                                    </div>
                                  </div>
                                }
                                onChange={
                                  (e) => {
                                    togglePastEventsEnabled(!pastEventsEnabled);

                                    saveTeamMembershipCalendarState(csrfToken, team, currentTeamMembership, {
                                      calendar_past_events_enabled: !pastEventsEnabled
                                    });
                                  }
                                } />
              <CategoryCheckBox htmlFor={"calendar-cancelled-events-enabled"}
                                isChecked={cancelledEventsEnabled}
                                label={
                                  <div className='d-flex align-items-center'>
                                    <img src="icons/x-square.svg" style={{width: "14px", marginRight: "4px"}} />
                                    <div className='text-truncate'>
                                      Canceled Events
                                    </div>
                                  </div>
                                }
                                onChange={
                                  (e) => {
                                    toggleCancelledEventsEnabled(!cancelledEventsEnabled);

                                    saveTeamMembershipCalendarState(csrfToken, team, currentTeamMembership, {
                                      calendar_cancelled_events_enabled: !cancelledEventsEnabled
                                    });
                                  }
                                } />
            </div>
          </div>
        ) : null}
      </div>

      <div className='card-body flex-grow-0' style={{padding: "20px 15px", "borderTop": "1px solid var(--od-c-f5f5f5, #f5f5f5)"}}>
        <div className='d-flex justify-content-between align-items-center position-relative'>
          <p className='small mb-0'>
            <strong style={{fontSize: "14px"}}>Tags</strong>
          </p>
          <a href="#"
              onClick={
                (e) => {
                  e.preventDefault();

                  var updated = {
                    ...currentTeamMembership,
                    tags_menu_open: !currentTeamMembership.tags_menu_open
                  }

                  currentTeamMembershipChanged(updated);
                  saveTeamMembershipCalendarState(csrfToken, team, currentTeamMembership, {
                    tags_menu_open: updated.tags_menu_open
                  });
                }
              }
              className='text-muted small stretched-link'>
            {tagsOpen ? (
              <i className="fas fa-chevron-up"></i>
            ) : (
              <i className="fas fa-chevron-down"></i>
            )}
          </a>
        </div>
        {tagsOpen ? (
          <div className='row'>
            <div className='col-12'
                  style={{
                    marginTop: "5px",
                    padding: "0 11px",
                    maxHeight: "200px",
                    overflowY: "auto"
                  }}>
              <TagFilter team={team}
                          csrfToken={csrfToken}
                          scope="CalendarEvent"
                          currentTags={selectedTags}
                          onChange={tags => {
                            setSelectedTags(tags);
                            fetchCalendarEventsForSelectedVenues(team, selectedRooms, tags);
                            dataTableFiltersChanged({
                              ...dataTableFilters,
                              tags: tags
                            });
                            var updated = {
                              ...currentTeamMembership,
                              calendar_tag_names: tags
                            };
                            currentTeamMembershipChanged(updated);
                            saveTeamMembershipCalendarState(csrfToken, team, currentTeamMembership, {
                              calendar_tag_names: tags
                            });
                          }}
                        />
            </div>
          </div>
        ) : null}
      </div>
    </div>
  )
}

CalendarMenu.propTypes = {
  team: PropTypes.object.isRequired,
  csrfToken: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
  currentTeamMembership: PropTypes.object.isRequired,
  saveTeamMembershipCalendarState: PropTypes.func.isRequired,
  currentTeamMembershipChanged: PropTypes.func.isRequired,
  venuesOptions: PropTypes.array,
  setSelectedVenues: PropTypes.func.isRequired,
  fetchCalendarEventsForSelectedVenues: PropTypes.func.isRequired,
  selectedTags: PropTypes.array,
  fetchTeamVenueConflicts: PropTypes.func.isRequired,
  dataTableFilters: PropTypes.object,
  dataTableFiltersChanged: PropTypes.func.isRequired,
  venueOwnerships: PropTypes.array,
  canSelectMultipleVenues: PropTypes.bool,
  venueOwnershipsChanged: PropTypes.func.isRequired,
  onSaleEnabled: PropTypes.bool,
  announcedEnabled: PropTypes.bool,
  confirmedEnabled: PropTypes.bool,
  holdsEnabled: PropTypes.bool,
  pastEventsEnabled: PropTypes.bool,
  cancelledEventsEnabled: PropTypes.bool,
  toggleOnSaleEnabled: PropTypes.func.isRequired,
  toggleAnnouncedEnabled: PropTypes.func.isRequired,
  toggleConfirmedEnabled: PropTypes.func.isRequired,
  toggleHoldsEnabled: PropTypes.func.isRequired,
  togglePastEventsEnabled: PropTypes.func.isRequired,
  toggleCancelledEventsEnabled: PropTypes.func.isRequired,
  setSelectedTags: PropTypes.func.isRequired,
  searchTermChanged: PropTypes.func.isRequired,
  dataTableEl: PropTypes.object,
  preSaleEnabled: PropTypes.bool,
  togglePreSaleEnabled: PropTypes.func.isRequired,
  artistPreSaleEnabled: PropTypes.bool,
  toggleArtistPreSaleEnabled: PropTypes.func.isRequired,
  browser: PropTypes.object.isRequired,
  datesAreOnSameDay: PropTypes.func.isRequired,
  setGoToSpecificDate: PropTypes.func.isRequired,
  scrollCalendarToDate: PropTypes.func.isRequired,
  setTeamMembershipCurrentDate: PropTypes.func.isRequired,
  calendarContainerRef: PropTypes.object,
  rooms: PropTypes.array,
  selectedRooms: PropTypes.array,
  setSelectedRooms: PropTypes.func.isRequired,
  roomsChanged: PropTypes.func.isRequired,
  reorderRooms: PropTypes.func.isRequired,
  calendarEventSeries: PropTypes.array,
  isMobileDropdown: PropTypes.bool,
};

export default CalendarMenu;
